<template>
  <div class="column">
    <div class="container container_com-fundo container_com-margem">
      <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
      <alerta :tipo="tipoDeAlerta" :texto="mensagemDeAlerta" />
      <form
        @submit.prevent="cadastrarEmpreendimento"
        class="cadastro-de-empreendimento formulario"
      >
        <h2 class="titulo titulo_grande">
          Preencha todos os campos obrigatórios abaixo para cadastrar o
          empreendimento
        </h2>
        <h3 class="subtitle is-5">
          <i class="fal fa-user-hard-hat"></i> Dados da construtora
        </h3>
        <div class="grade__linha">
          <div class="grade__coluna grade__coluna_4">
            <label class="label" id="nome">Informe o nome da Construtora</label>
            <input
              name="nomeDaConstrutora"
              type="text"
              id="nomeDoEmpreendimento"
              class="input uppercase"
              alt="Informe o nome da Construtora"
              placeholder="Ex: RG ENGENHARIA LTDA"
              v-model="empreendimento.NomeDaConstrutora"
              required
            />
            <span class="example-input">Ex: RG ENGENHARIA LTDA</span>
          </div>

          <div class="grade__coluna grade__coluna_4">
            <label class="label">CNPJ</label>
            <input
              name="numeroCNPJdaConstrutora"
              type="text"
              id="nomeDoEmpreendimento"
              class="input"
              placeholder="Ex: 00.192.450/0001-23"
              v-model="empreendimento.CnpjDaConstrutora"
              v-mask="'99.999.999/9999-99'"
              required
            />
            <span class="example-input">Ex: 00.192.450/0001-23</span>
          </div>
          <div class="grade__coluna grade__coluna_4">
            <label class="label">Dados bancários</label>
            <input
              name="dadosBancariosConstutora"
              type="text"
              id="nomeDoEmpreendimento"
              class="input uppercase"
              placeholder="Ex: AGENCIA 2054 OP 003 C/C 2708-6"
              v-model="empreendimento.ContaDaConstrutora"
              required
            />
            <span class="example-input"
              >Ex: AGENCIA 2054 OP 003 C/C 2708-6</span
            >
          </div>
        </div>

        <h3 class="subtitle is-5">
          <i class="fal fa-building"></i> Novo empreendimento
        </h3>
        <div class="grade__linha">
          <div class="grade__coluna grade__coluna_4">
            <label class="label">Projeto</label>
            <select
              v-model="empreendimento.ProjetoDeSubsidioId"
              required
              @change="obterCotas"
            >
              <option
                v-for="projeto in projetos"
                :value="projeto.Id"
                :selected="
                  projeto.Id === empreendimento.ProjetoDeSubsidioId
                    ? 'selected'
                    : ''
                "
              >
                {{ projeto.Nome }}
              </option>
            </select>
          </div>
          <div class="grade__coluna grade__coluna_4">
            <label class="label">Cidade</label>
            <select
              v-model="empreendimento.CidadeId"
              required
              @change="obterCotas"
            >
              <option
                v-for="cidade in cidades"
                :value="cidade.Id"
                :selected="
                  cidade.Id === empreendimento.CidadeId ? 'selected' : ''
                "
              >
                {{ cidade.Nome }}
              </option>
            </select>
          </div>
          <div class="grade__coluna grade__coluna_4">
            <label class="label">Tipo de imóvel</label>
            <select v-model="empreendimento.TipoDeEmpreendimento" required>
              <option
                v-for="tipoDeEmpreendimento in tiposDeEmpreendimento"
                :value="tipoDeEmpreendimento.Id"
                :selected="
                  empreendimento.TipoDeEmpreendimento ===
                  tipoDeEmpreendimento.Id
                    ? 'selected'
                    : ''
                "
              >
                {{ tipoDeEmpreendimento.Nome }}
              </option>
            </select>
          </div>
          <div class="grade__coluna grade__coluna_4">
            <label class="label" for="nomeDoEmpreendimento">Nome</label>
            <input
              name="nomeDoEmpreendimento"
              type="text"
              id="nomeDoEmpreendimento"
              class="input uppercase"
              placeholder="Ex: CONDOMÍNIO RESIDENCIAL ITACIRA"
              v-model="empreendimento.Nome"
              required
            />
            <span class="example-input"
              >Ex: CONDOMÍNIO RESIDENCIAL ITACIRA</span
            >
          </div>
          <div
            v-if="projetoEhBonusMoradia()"
            class="grade__coluna grade__coluna_1"
          >
            <label class="label" for="quantidadeDeImoveisDisponiveis"
              >Total de imóveis do empreendimento</label
            >
            <input
              name="quantidadeDeImoveisDisponiveis"
              type="number"
              id="quantidadeDeImoveisDisponiveis"
              class="input uppercase"
              placeholder="Ex: 100"
              v-model="empreendimento.QuantidadeDeImoveisDisponiveis"
              required
            />
            <span class="example-input">Ex: 100</span>
          </div>
          <div
            v-if="projetoEhBonusMoradia()"
            class="grade__coluna grade__coluna_1"
          >
            <label class="label" for="totalDeCotas"
              >Total de cotas disponibilizadas</label
            >
            <input
              name="totalDeCotas"
              type="number"
              id="totalDeCotas"
              class="input uppercase"
              placeholder="Ex: 100"
              v-model="empreendimento.CotaDeImoveis"
              required
            />
            <span class="example-input">Ex: 100</span>
          </div>
          <div
            v-if="projetoEhBonusMoradia()"
            class="grade__coluna grade__coluna_4"
          >
            <p class="texto-informativo">
              Total de cotas disponíveis no município:
              <strong>{{ this.cotasDisponiveisDoMunicipio }}</strong>
            </p>
          </div>
          <div
            class="grade__coluna grade__coluna_4"
            style="display: flex; align-items: center"
          >
            <label class="formulario__label">
              <input
                type="checkbox"
                v-model="empreendimento.EhTerrenoPublicoDoado"
              />
              Terreno público doado
            </label>
          </div>
        </div>
        <h3 class="subtitle is-5">
          <i class="fal fa-building-columns"></i> Dados de correspondentes
          bancários
        </h3>
        <div class="formulario">
          <div class="grade__linha">
            <div class="grade__coluna grade__coluna_2">
              <input
                id="cpf"
                type="text"
                placeholder="Insira somente números do CPF"
                v-model="cpfDoCorrespondente"
                v-mask="'999.999.999-99'"
              />
            </div>
            <div class="grade__coluna grade__coluna_4">
              <button
                v-if="true"
                type="button"
                @click="adicionarCorrespondente"
                class="no-print botao botao_cor-terciaria botao_com-icone-para-direita botao_sem-preenchimento botao_medio"
              >
                <i class="fa fa-plus" aria-hidden="true"></i>
                Adicionar
              </button>
            </div>
          </div>
          <div class="grade__linha">
            <div
              class="grade__coluna grade__coluna_2"
              v-for="(correspondente, index) in empreendimento.Usuarios"
              :key="index"
            >
              <section class="card-correspondente">
                <header class="card-header">
                  <i class="fa-light fa-user"></i>
                  <button
                    type="button"
                    class="delete-btn"
                    @click="removerCorrespondente(index)"
                    title="Excluir"
                  >
                    <i class="fa-light fa-trash"></i>
                  </button>
                </header>
                <div class="card-body">
                  <h2 class="card-title">{{ correspondente.Nome }}</h2>
                  <p class="card-subtitle">{{ correspondente.Cpf }}</p>
                </div>
              </section>
            </div>
          </div>
        </div>
        <hr />
        <div class="grade__linha">
          <router-link
            :to="{ name: 'ListaDeEmpreendimentos' }"
            class="botao botao_cinza botao_medio u-margem-direita-pequena"
            :class="{ 'is-disabled': loading.visivel }"
            >Cancelar</router-link
          >
          <button
            type="submit"
            class="botao botao_cor-terciaria botao_medio"
            :class="{ 'is-loading': loading.visivel }"
          >
            Salvar empreendimento
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
import Loading from "../shared/Loading";
import Alerta from "../shared/Alerta";

export default {
  name: "cadastrar-empreendimento",
  directives: { mask: AwesomeMask },
  components: { Loading, Alerta },
  data() {
    return {
      empreendimento: {
        CidadeId: null,
        TipoDeEmpreendimento: null,
        ProjetoDeSubsidioId: null,
        QuantidadeDeImoveisDisponiveis: 0,
        CotaDeImoveis: 0,
        EhTerrenoPublicoDoado: false,
        Usuarios: [],
      },
      cidades: this.cidades || [],
      projetos: this.projetos || [],
      construtoras: this.construtoras || [],
      cotasDisponiveisDoMunicipio: null,
      cpfDoCorrespondente: null,
      tiposDeEmpreendimento: [
        {
          Id: null,
          Nome: "Selecione um tipo de imóvel",
        },
        {
          Id: 1,
          Nome: "Apartamento",
        },
        {
          Id: 2,
          Nome: "Casa",
        },
        {
          Id: 3,
          Nome: "Casa e apartamento",
        },
      ],
      loading: {
        visivel: false,
      },
      mensagemDeAlerta: null,
      tipoDeAlerta: null,
    };
  },
  created() {
    this.$api
      .get("/Construtora")
      .then((response) => {
        this.construtoras = [{ Id: null, Nome: "Selecione uma construtora" }];
        this.construtoras = this.construtoras.concat(response.data);
        return response;
      })
      .catch((error) => {
        console.error(error);
      });

    this.$api
      .get("/Cidade")
      .then((response) => {
        this.cidades = [{ Id: null, Nome: "Selecione uma cidade" }];
        this.cidades = this.cidades.concat(response.data);
        return response;
      })
      .catch((error) => {
        this.tratarErro(error);
      });

    this.$api
      .get("/Projeto")
      .then((response) => {
        this.projetos = [{ Id: null, Nome: "Selecione um projeto" }];
        this.projetos = this.projetos.concat(response.data);
        return response;
      })
      .catch((error) => {
        this.tratarErro(error);
      });
  },
  methods: {
    projetoEhBonusMoradia() {
      if (!this.empreendimento.ProjetoDeSubsidioId) return false;
      const projeto = this.projetos.filter(
        (p) => p.Id == this.empreendimento.ProjetoDeSubsidioId
      )[0];
      return projeto.EhBonusMoradia;
    },
    obterCotas() {
      this.cotasDisponiveisDoMunicipio = null;

      if (
        !this.empreendimento.CidadeId ||
        !this.empreendimento.ProjetoDeSubsidioId
      )
        return;

      this.$api
        .get(
          `/Cidade/ObterCotasDisponiveis/${this.empreendimento.CidadeId}/${this.empreendimento.ProjetoDeSubsidioId}`
        )
        .then((response) => {
          this.cotasDisponiveisDoMunicipio = response.data;
        })
        .catch((error) => {
          this.tratarErro(error);
        });
    },
    cadastrarEmpreendimento() {
      this.exibirCarregamento(
        "Só um momento, estamos cadastrando o novo empreendimento..."
      );
      const empreendimento = JSON.parse(
        JSON.stringify(this.$data.empreendimento)
      );
      empreendimento.Nome = empreendimento.Nome.toUpperCase();
      empreendimento.NomeDaConstrutora =
        empreendimento.NomeDaConstrutora.toUpperCase();
      empreendimento.ContaDaConstrutora =
        empreendimento.ContaDaConstrutora.toUpperCase();

      this.$api
        .post("/Empreendimento", empreendimento)
        .then(() => {
          this.$router.push({ name: "ListaDeEmpreendimentos" });
        })
        .catch((error) => {
          this.tratarErro(error);
        });
    },
    exibirCarregamento(mensagem) {
      this.loading.visivel = true;
      this.loading.mensagem = mensagem;
    },
    esconderCarregamento() {
      this.loading.visivel = false;
      this.loading.mensagem = null;
    },
    tratarErro(error) {
      this.esconderCarregamento();
      this.tipoDeAlerta = "erro";
      const mensagensDeErro = error.response.data.Message;
      this.mensagemDeAlerta =
        mensagensDeErro ||
        "Desculpe, ocorreu um erro interno. Tente novamente ou contate o suporte";
    },
    adicionarCorrespondente() {
      this.exibirCarregamento("");
      const cpfDoCorrespondente = this.removerMascaraCpf(
        this.cpfDoCorrespondente
      );
      const correspondenteJaFoiAdicionado = this.empreendimento.Usuarios.some(
        (p) => p.Cpf === cpfDoCorrespondente
      );
      if (correspondenteJaFoiAdicionado) {
        this.exibirAlerta("CPF já adicionado", "atencao");
        this.cpfDoCorrespondente = null;
        this.esconderCarregamento();
        return;
      }

      this.$api
        .get(`/Usuario/${cpfDoCorrespondente}`)
        .then((resultado) => {
          this.esconderCarregamento();
          if (resultado.data === null) {
            let mensagem = "Cpf não encontrado";
            this.exibirAlerta(mensagem, "atencao");
          } else {
            const usuario = resultado.data;
            var correspondente = {
              Cpf: usuario.Cpf,
              Login: usuario.Login,
              Nome: usuario.Nome,
            };
            this.empreendimento.Usuarios.push(correspondente);
            this.cpfDoCorrespondente = null;
          }
        })
        .catch((error) => {
          this.tratarErro(error);
        });
    },
    removerCorrespondente(index) {
      this.empreendimento.Usuarios.splice(index, 1);
    },
    removerMascaraCpf(cpf) {
      return cpf.replace(/\D/g, "");
    },
    exibirAlerta(mensagem) {
      this.tipoDeAlerta = "erro";
      this.mensagemDeAlerta =
        mensagem ||
        "Ocorreu um erro interno. Tente novamente ou contate o suporte";
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>



// WEBPACK FOOTER //
// CadastrarEmpreendimento.vue?59c5c350